import {
  isBreakpointMobile,
  ReducerContext,
  shareAbdooLink,
  useBreakpoint,
} from '@abdoo/common';
import { Button, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { BsShareFill } from 'react-icons/bs';

export const StartManaging = () => {
  const { userSettingsState } = useContext(ReducerContext);
  const breakpoint = useBreakpoint();
  const isMobile = isBreakpointMobile(breakpoint);

  return (
    <Grid
      container
      display={'flex'}
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      mt={2}
    >
      <Grid item>
        <Typography
          maxWidth={'20rem'}
          component="div"
          variant={isMobile ? 'caption' : 'body2'}
        >
          Share this link with your Direct Reports so you can all use Abdoo together. Just
          click the button below.
        </Typography>
      </Grid>
      <Grid item>
        <Button
          sx={{ width: '90px' }}
          variant="text"
          style={{ display: 'block', textAlign: 'center', float: 'right' }}
          onClick={() => shareAbdooLink(userSettingsState.userId)}
        >
          <BsShareFill size={isMobile ? 38 : 48} />
          <Typography variant="button">Share</Typography>
        </Button>
      </Grid>
    </Grid>
  );
};
